<template>
  <div class="content" style="background-color: #fff;height: auto;">
    <!-- <a href="javascript:void(0)" class="call">未接号码一键外呼</a> -->
    <div class="taskList">
      <div class="taskitem" v-for="item in list">
        <!-- <img src="../../assets/images/ck1.png" class="ckStatic"> -->
        <a href="javascript:void(0)" class="fb" v-if="item.status==4" @click="searchAiTaskDetail(item.id)">未接号码一键复拨</a>
        <div style="display: flex;justify-content: flex-start;align-items: center;">
          <span class="taskTitle" v-text="item.taskName">20170617美术宝</span>
          <span class="taskStatic" v-if="item.status==0" style="border-color: #C0C0C0;color: #C0C0C0;background:#fff;">导入中</span>
          <span class="taskStatic" v-if="item.status==1" style="border-color: #C0C0C0;color: #C0C0C0;background:#fff;">未开始</span>
          <span class="taskStatic" v-if="item.status==2">进行中</span>
          <span class="taskStatic" v-if="item.status==3" style="border-color: #C0C0C0;color: #C0C0C0;background:#fff;">已暂停</span>
          <span class="taskStatic" v-if="item.status==4" style="border-color: #07CF81;color: #07CF81;background:rgba(239,255,249,1);">已完成</span>
        </div>
        <div>
          <van-progress color="#8CBAFF" :percentage="percentage(item)" stroke-width=".08rem" :show-pivot="false" />
        </div>
        <div>
          <span class="taskPro" v-text="item.completeCount+'/'+item.totalCount">500/1000</span>
        </div>
        <div>
          <span class="taskTmp" v-text="'话术模板：'+item.templateName"></span>
        </div>
        <div>
          <span class="taskCreatTime" v-text="'创建时间：'+item.createTime"></span>
        </div>
      </div>
      <!-- <div class="taskitem active">
                <img src="../../assets/images/ck2.png" class="ckStatic">
                <div style="display: flex;justify-content: flex-start;align-items: center;">
                    <span class="taskTitle">20170617美术宝</span>
                    <span class="taskStatic">已开始</span>
                </div>
                <div>
                    <van-progress color="#8CBAFF" :percentage="50" stroke-width=".08rem" :show-pivot="false"/>
                </div>
                <div>
                    <span class="taskPro">500/1000</span>
                </div>
                <div>
                    <span class="taskTmp">话术模板：美术宝</span>
                </div>
                <div>
                    <span class="taskCreatTime">创建时间：2020.01.11 11:30</span>
                </div>
            </div> -->
    </div>
  </div>
</template>
<script>
import { getTaskListByOrganizationId, newAiTaskDetail, missedNumberOneKeyOutboundCall } from '../../api';
export default {
  name: 'template',
  data() {
    return {
      organizationId: "",
      list: []
    }
  },
  methods: {
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]); return "";
    },
    percentage(res) {
      if (res.completeCount == 0) {
        return 0;
      }
      return Math.round(res.completeCount / res.totalCount * 100)
    },
    getTaskListByOrganizationId() {
      var that = this;
      getTaskListByOrganizationId("?organizationId=" + that.organizationId).then((res) => {
        if (res.code == 1) {
          that.list = res.data;
          if (that.list.length == 0) {
            that.$toast("您还没有创建任务！");
          }
        } else {
          that.$toast("错误信息:" + res.message);
        }
      });
    },
    searchAiTaskDetail(callTaskId) {
      var that = this;
      newAiTaskDetail("?callTaskId=" + callTaskId).then(res => {
        if (res.code == 1) {
          if (res.data.cCount == 0) {
            that.$toast("当前任务没有未接号码！");
            return;
          }
          that.$dialog.confirm({
            message: '当前任务共有未接号码' + res.data.cCount + "条。确认复拨吗？"
          }).then(() => {
            // on confirm
            // console.log("confirm")
            missedNumberOneKeyOutboundCall("?callTaskId=" + callTaskId).then((res) => {
              if (res.code == 1) {
                that.$toast('操作成功!');
                that.getTaskListByOrganizationId();
              } else {
                that.$toast("错误信息:" + res.message);
              }
            });
          }).catch(() => {
            // on cancel
            console.log("cancel")
          });
        } else {
          that.$toast(res.message);
        }
      })
    }
  },
  mounted() {
    this.organizationId = this.getQueryString("id");
    this.getTaskListByOrganizationId();
  }
}
</script>
<style type="text/css">
.call {
  width: 6.9rem;
  height: 0.88rem;
  line-height: 0.88rem;
  color: #fff;
  font-size: 0.32rem;
  text-align: center;
  display: block;
  background: rgba(59, 137, 255, 1);
  border: 0.01rem solid rgba(43, 118, 231, 1);
  border-radius: 0.08rem;
  margin: 0.3rem auto;
}
.taskList {
  width: 6.9rem;
  margin: 0 auto;
  padding: 0.2rem 0;
}
.taskitem {
  border: 0.03rem solid rgba(234, 239, 248, 1);
  border-radius: 0.08rem;
  height: 2.32rem;
  margin-bottom: 0.2rem;
  position: relative;
  padding: 0.1rem 0.3rem;
}
.taskitem.active {
  border-color: #3b89ff;
}
.taskitem .fb {
  background: rgba(59, 137, 255, 1);
  border: 0.01rem solid rgba(43, 118, 231, 1);
  font-size: 0.2rem;
  color: #fff;
  display: block;
  height: 0.42rem;
  line-height: 0.4rem;
  border-radius: 0.2rem;
  width: 2rem;
  text-align: center;
  position: absolute;
  bottom: 0.2rem;
  right: 0.3rem;
}
.ckStatic {
  position: absolute;
  right: -0.015rem;
  bottom: -0.015rem;
  display: block;
  width: 0.46rem;
  height: 0.46rem;
}
.taskTitle {
  color: #222222;
  font-size: 0.32rem;
  font-weight: bold;
  display: block;
  width: 5rem;
  height: 0.42rem;
  line-height: 0.42rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.taskStatic {
  width: 1.24rem;
  height: 0.42rem;
  line-height: 0.38rem;
  text-align: center;
  font-size: 0.24rem;
  border-radius: 0.21rem;
  margin: 0.14rem 0;
  color: #3b89ff;
  border: 0.02rem solid rgba(59, 137, 255, 1);
  background: rgba(234, 244, 254, 1);
}
.taskPro {
  font-size: 0.22rem;
  color: #a4a4a4;
  line-height: 0.4rem;
}
.taskTmp {
  font-size: 0.26rem;
  color: #222222;
  line-height: 0.4rem;
  display: block;
  width: 4rem;
  height: 0.4rem;
  line-height: 0.4rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.taskCreatTime {
  font-size: 0.24rem;
  color: #777777;
}
</style>


// WEBPACK FOOTER //
// src/views/task/taskList.vue


// WEBPACK FOOTER //
// src/views/task/taskList.vue